<div class="title" mat-dialog-title>
  <h2 class="spacer">{{ title }}</h2>
  <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content class="content-wrapper">
  <div class="video-container">
    <iframe
      class="iframe"
      width="100%"
      height="100%"      
      [src]="sanitizedUrl()"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
  <div class="carrousel-container">
    <lsa-video-vertical-list
      [selectedVideo]="selectedVideo()"
      (videoClick)="selectVideo($event)"
      [videos]="videos"
    ></lsa-video-vertical-list>
  </div>
</mat-dialog-content>
